import { ReactNode } from 'react';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip, Typography } from '@mui/material';

type formattedUILabelProps = {
  uiLabel: string;
  description?: string | null;
  isRequired?: boolean;
};

const FormattedUILabel = (props: formattedUILabelProps): ReactNode => {
  const { uiLabel, description, isRequired } = props;
  let formattedLabel: string = uiLabel || '';
  if (isRequired) {
    formattedLabel += ' *';
  }
  if (description) {
    // adding eye button on hover showing the description as tooltip
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography>{formattedLabel}</Typography>
        <Tooltip title={description} placement="top" arrow>
          <InfoOutlineIcon
            sx={{ ml: 0.5, fontSize: 15, verticalAlign: 'middle', cursor: 'pointer' }}
          />
        </Tooltip>
      </Box>
    );
  }
  return <Typography>{formattedLabel}</Typography>;
};

export default FormattedUILabel;
